module.exports = __webpack_public_path__ + "static/media/google.99dcc21e.svg";